var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0047 0.040967C18.0043 0.0411114 18.0039 0.0412197 18.0035 0.0413641L0.503572 5.79762C-0.119235 6.00245 -0.1795 6.83902 0.407718 7.1264L5.82428 9.77735V15.1945C5.82428 15.8096 6.5622 16.1375 7.04143 15.7492L9.03465 14.134L10.8231 16.6849C11.1542 17.1572 11.8895 17.0844 12.1189 16.5613L18.9384 1.00365C19.1833 0.445466 18.662 -0.165163 18.0047 0.040967ZM6.48694 8.48535L2.66007 6.61243L14.1663 2.82771L6.48694 8.48535ZM7.30858 13.6535V11.6721L8.19445 12.9357L7.30858 13.6535ZM11.2854 14.7817C11.2288 14.7011 7.58946 9.51033 7.57744 9.49315L16.4778 2.93595L11.2854 14.7817Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.9b766cded9cfd7b07b4d540861a5b6ad.svg";
export { ForwardRef as ReactComponent };